import { render } from "./B2bLoginPasswordFormAccionaEnergia.vue?vue&type=template&id=23f2d6dc&scoped=true&lang=pug"
import script from "./B2bLoginPasswordFormAccionaEnergia.vue?vue&type=script&lang=js"
export * from "./B2bLoginPasswordFormAccionaEnergia.vue?vue&type=script&lang=js"

import "./B2bLoginPasswordFormAccionaEnergia.vue?vue&type=style&index=0&id=23f2d6dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f2d6dc"]])

export default __exports__